import { useMutation } from '@apollo/client';
import DELETE_TAG_MUTATION from '../mutations/DELETE_TAG_MUTATION';

export function useDeleteTagMutation() {
    return useMutation( DELETE_TAG_MUTATION );
}
